export default {
  unAuthorized: {
    tabTitle: "UnAuthorized",
    text: {
      title: "403",
      describe: "Sorry! The page you are looking for couldn't open.",
    },
  },
};
